import React, { FC, useContext, useEffect, useState } from 'react';
import StoreUtilsContext from './StoreUtilsContext';
import MinimalLoader from '../components/presentation/MinimalLoader';

export default function withFreshStore<T>(ComponentType: FC<T>): FC<T> {
  return ({ children, ...props }) => {
    const storeUtils = useContext(StoreUtilsContext);
    const [isFresh, setIsFresh] = useState(false);

    if (!storeUtils) {
      throw new Error(`Store utils context not set.`);
    }

    useEffect(() => {
      storeUtils.resetStore();
      setIsFresh(true);
    }, []);

    if (!isFresh) {
      return <MinimalLoader />;
    }

    if (children) {
      return <ComponentType {...(props as any)}>{children}</ComponentType>;
    }

    return <ComponentType {...(props as any)} />;
  };
}
